<template>
  <footer class="footer">
    <div class="container footer__inner">
      <p class="footer__copy">© 2025 Go Trust. All rights reserved.</p>
      <nav class="footer__links">
        <a href="#" @click.prevent="$emit('link-click')">关于我们</a>
        <a href="#" @click.prevent="$emit('link-click')">帮助中心</a>
        <a href="#" @click.prevent="$emit('link-click')">隐私政策</a>
        <a href="#" @click.prevent="$emit('link-click')">用户协议</a>
      </nav>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'AppFooter',
  emits: ['link-click'],
}
</script>

<style scoped>
.footer {
  background: var(--color-primary);
  padding: 20px 0;
}

.footer__inner {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
  text-align: center;
}

.footer__copy {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.6);
}

.footer__links {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  gap: 16px;
}

.footer__links a {
  font-size: 12px;
  color: rgba(255, 255, 255, 0.8);
  transition: color 0.2s;
}

.footer__links a:hover {
  color: var(--color-white);
}

@media (min-width: 768px) {
  .footer__inner {
    flex-direction: row;
    justify-content: space-between;
    text-align: left;
  }
}
</style>
